import React, { useState, useEffect, useMemo } from 'react';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import CrudPage from '../../../components/common/CrudPage';
import { cardService, contentCategoryService } from '../../../services/cms/contentManagementService';

const { Text } = Typography;

const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
  { title: 'TÊN', dataIndex: 'title', key: 'title', render: (t) => <Text strong>{t}</Text> },
  { title: 'ẢNH', dataIndex: 'image_url', key: 'image_url', width: 100, render: (u) => u ? <img src={u} alt="" style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 4 }} /> : '-' },
  { title: 'DANH MỤC', dataIndex: 'category_id', key: 'category_id', width: 150, render: (val, r) => r.category_name ? `[${val}] ${r.category_name}` : (val || '-') },
  { title: 'MÔ TẢ', dataIndex: 'description', key: 'description', ellipsis: true },
  { title: 'NGƯỜI TẠO', dataIndex: 'author_name', key: 'author_name', width: 140, render: (val, r) => val || r.create_by || r.created_by || '-' },
  { title: 'NGÀY TẠO', dataIndex: 'create_time', key: 'create_time', width: 140, render: (t) => t ? dayjs(t).format('DD/MM/YYYY HH:mm') : '-' },
];

const QuanLyThiep = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    contentCategoryService.listActive().then((res) => {
      if (Array.isArray(res)) {
        setCategories(res.map((c) => ({ label: `[${c.id}] ${c.title}`, value: c.id })));
      }
    });
  }, []);

  const formFields = useMemo(() => [
    { name: 'title', label: 'Tên thiệp', type: 'input', rules: [{ required: true, message: 'Vui lòng nhập!' }] },
    { name: 'category_id', label: 'Danh mục', type: 'select', options: categories, propsInput: { showSearch: true } },
    { name: 'description', label: 'Mô tả', type: 'textarea' },
    { name: 'image_url', label: 'Ảnh thiệp', type: 'upload-cdn' },
    { name: 'metadata', label: 'Metadata', type: 'textarea', propsInput: { rows: 2 } },
  ], [categories]);

  const filterFields = useMemo(() => [
    {
      label: 'Chọn danh mục',
      value: 'category_id',
      options: [{ label: 'Tất cả danh mục', value: '' }, ...categories],
    },
  ], [categories]);

  return (
    <CrudPage
      title="QUẢN LÝ THIỆP"
      subTitle="Quản lý thiệp trong hệ thống"
      itemsName="Thiệp"
      queryKey="cardList"
      service={cardService}
      columns={columns}
      formFields={formFields}
      filterFields={filterFields}
      searchPlaceholder="Tìm kiếm..."
      addButtonLabel="Thêm thiệp"
    />
  );
};

export default QuanLyThiep;
